export default __webpack_public_path__ + "static/Leisha-McKinley-Beach-hero-mobile-f6c9c8db8d10a1d646d4522648694d50.jpg";